import { LoadingOverlay, SimpleGrid, Stack, Text } from '@mantine/core';
import { Panel } from 'components/Panel';
import { i18nKeys, useTranslation } from 'locales';
import { useState } from 'react';
import { UpdateFooterSchema, useLoadInvoiceFooter, useUpdateInvoiceFooter } from '../api';
import { EditFooterItemModal } from './EditFooterItemModal';
import { FooterItem } from './FooterItem';

export const InvoiceFooterCard = () => {
  const { t } = useTranslation();
  const { invoiceFooter, isInvoiceFooterLoading } = useLoadInvoiceFooter();
  const { updateInvoiceFooter } = useUpdateInvoiceFooter();
  const [selectedItemIndex, setSelectedItemIndex] = useState<number | null>(null);

  return (
    <Panel title={t(i18nKeys.SETTINGS.INVOICING.FOOTER.TITLE)} withBorder>
      <Stack my="md">
        <Text size="sm" c="dimmed">
          {t(i18nKeys.SETTINGS.INVOICING.FOOTER.DESCRIPTION)}
        </Text>
        {isInvoiceFooterLoading || invoiceFooter == null ? (
          <LoadingOverlay visible />
        ) : (
          <>
            <SimpleGrid cols={3} spacing="lg">
              {invoiceFooter.fields.map((item, index) => (
                <FooterItem
                  // biome-ignore lint/suspicious/noArrayIndexKey: the footer is a fixed 9-slot positional list edited in place by index, so the index is each cell's stable identity
                  key={index}
                  item={item}
                  onClickEdit={() => setSelectedItemIndex(index)}
                />
              ))}
            </SimpleGrid>
            <EditFooterItemModal
              onClose={() => setSelectedItemIndex(null)}
              isOpen={selectedItemIndex != null}
              item={selectedItemIndex != null ? invoiceFooter.fields[selectedItemIndex] : null}
              onSave={newItem => {
                if (selectedItemIndex == null) return;
                updateInvoiceFooter(
                  UpdateFooterSchema.parse(
                    invoiceFooter.fields.toSpliced(selectedItemIndex, 1, newItem),
                  ),
                  { onSuccess: () => setSelectedItemIndex(null) },
                );
              }}
            />
          </>
        )}
      </Stack>
    </Panel>
  );
};
